import { CustomTabPanel } from "@/erp";
import { sizeTab, a11yProps, texto } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import VoucherPreagendaPage from "./vocuher-preagenda/VoucherPreagendaPage";

export default function RevisionVoucherPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={texto.comprobante_pago}
      visibleReport={false}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Pendiente'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <VoucherPreagendaPage />
      </CustomTabPanel>
      
    </SingleTableBoxScene>
  );



}